const MAC = typeof navigator !== 'undefined' && /Mac|iP(hone|ad)/.test(navigator.platform);
/** The shortcut modifier as the operator's keyboard shows it. */
export const MOD = MAC ? '⌘' : 'Ctrl+';
